// Pierro – Upsell Popup (aparece ao adicionar ao carrinho)
(function () {
  'use strict';

  const CATEGORY_MAP = [
    { match: ['baby tee', 'camiseta', 'regata', 'camisa'],     suggest: ['calcas', 'bermudas', 'shorts'] },
    { match: ['calça', 'calca'],                                suggest: ['camisetas', 'regatas', 'baby-tee'] },
    { match: ['bermuda'],                                       suggest: ['camisetas', 'regatas', 'baby-tee'] },
    { match: ['short suplex', 'short conjunto', 'nano short'],  suggest: ['camisetas', 'regatas', 'baby-tee'] },
    { match: ['moleton', 'moletom'],                            suggest: ['calcas', 'bermudas'] },
    { match: ['slim bag', 'tote bag'],                          suggest: ['camisetas', 'regatas'] },
    { match: ['saia'],                                          suggest: ['camisetas', 'regatas', 'baby-tee'] },
    { match: ['top vestido', 'vestido'],                        suggest: ['bags'] },
    { match: ['biquini sutiã', 'biquini sutia'],                suggest: ['biquinis'] },
    { match: ['biquini calcinha', 'biquini calçinha'],          suggest: ['biquinis'] },
  ];

  function getCollections(title) {
    const t = (title || '').toLowerCase();
    for (const rule of CATEGORY_MAP) {
      if (rule.match.some(kw => t.includes(kw))) return rule.suggest;
    }
    return null;
  }

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  async function fetchFromCollection(handle, limit) {
    try {
      const r = await fetch('/collections/' + handle + '/products.json?limit=' + (limit || 8));
      return r.ok ? (await r.json()).products || [] : [];
    } catch (e) { return []; }
  }

  async function fetchRecommendations(productId, limit) {
    try {
      const r = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + (limit || 8));
      return r.ok ? (await r.json()).products || [] : [];
    } catch (e) { return []; }
  }

  async function getSuggestions(productId, productTitle, excludeId) {
    const collections = getCollections(productTitle);
    let products = [];
    if (collections) {
      const shuffled = collections.slice().sort(function() { return Math.random() - 0.5; });
      for (let i = 0; i < shuffled.length && products.length < 8; i++) {
        const more = await fetchFromCollection(shuffled[i], 8);
        products = products.concat(more);
      }
    }
    if (products.length < 3) {
      const recs = await fetchRecommendations(productId, 8);
      products = products.concat(recs);
    }
    const seen = {};
    seen[excludeId] = true;
    return products.filter(function(p) {
      if (seen[p.id]) return false;
      seen[p.id] = true;
      return true;
    }).slice(0, 3);
  }

  function renderCard(p) {
    const price  = formatMoney((p.variants[0] ? p.variants[0].price : 0) * 100);
    const imgRaw = p.featured_image || (p.images && p.images[0]);
    const imgSrc = typeof imgRaw === 'string' ? imgRaw : (imgRaw && imgRaw.src ? imgRaw.src : '');
    const img    = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + p.title + '" class="upsell-rec-img" loading="lazy">'
      : '<div class="upsell-rec-img"></div>';
    return '<a href="/products/' + p.handle + '" class="upsell-rec-card" onclick="document.getElementById(\'upsell-overlay\').setAttribute(\'hidden\',\'\')">'
      + img
      + '<p class="upsell-rec-name">' + p.title + '</p>'
      + '<p class="upsell-rec-price">' + price + '</p>'
      + '</a>';
  }

  function UpsellPopup() {
    this.overlay     = document.getElementById('upsell-overlay');
    if (!this.overlay) return;
    this.closeBtn    = this.overlay.querySelector('.upsell-close');
    this.addedEl     = document.getElementById('upsell-added-product');
    this.actionsEl   = document.getElementById('upsell-cart-info');
    this.recsSection = document.getElementById('upsell-recs-section');
    this.recsList    = document.getElementById('upsell-recs-list');
    this._pending    = false;
    this._init();
  }

  UpsellPopup.prototype._init = function() {
    var self = this;

    // Método primário: intercepta fetch /cart/add.js
    var origFetch = window.fetch.bind(window);
    window.fetch = function() {
      var args = Array.prototype.slice.call(arguments);
      var result = origFetch.apply(window, args);
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      if (url.indexOf('/cart/add') !== -1) {
        result.then(function(res) {
          if (!self._pending && !window.__freTeCalcRunning) {
            res.clone().json().then(function(data) {
              if (data && data.variant_id) {
                self._showFromAddData(data);
              }
            }).catch(function() {});
          }
          return res;
        }).catch(function() {});
      }
      return result;
    };

    // Método secundário: evento cart:update com variantId
    document.addEventListener('cart:update', function(e) {
      if (e.detail && e.detail.data && e.detail.data.variantId && !e.detail.data.didError && !self._pending && !window.__freTeCalcRunning) {
        self._onCartAdd(e);
      }
    });

    // Fecha
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function() { self.close(); });
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', function(e) {
        if (e.target === self.overlay) self.close();
      });
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !self.overlay.hidden) self.close();
    });
  };

  UpsellPopup.prototype._showFromAddData = function(addData) {
    var self = this;
    this._pending = true;
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var item = null;
      if (cart.items) {
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === String(addData.variant_id)) {
            item = cart.items[i];
            break;
          }
        }
      }
      if (!item) { self._pending = false; return; }
      self._renderTop(item, cart);
      self._showRecsLoading();
      self.open();
      getSuggestions(item.product_id, item.product_title, item.product_id).then(function(suggestions) {
        self._renderRecs(suggestions);
        self._pending = false;
      });
    }).catch(function() { self._pending = false; });
  };

  UpsellPopup.prototype._onCartAdd = function(event) {
    var self = this;
    var cart      = event.detail && event.detail.resource;
    var variantId = String((event.detail && event.detail.data && event.detail.data.variantId) || '');
    if (!cart || !variantId) return;
    var item = null;
    if (cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === variantId) { item = cart.items[i]; break; }
      }
    }
    if (!item) return;
    this._renderTop(item, cart);
    this._showRecsLoading();
    this.open();
    getSuggestions(item.product_id, item.product_title, item.product_id).then(function(suggestions) {
      self._renderRecs(suggestions);
    });
  };

  UpsellPopup.prototype._renderTop = function(item, cart) {
    var self = this;
    var count    = cart.item_count;
    var imgSrc   = item.image ? item.image.replace(/(\.\w+)$/, '_160x$1') : '';
    var variant  = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';

    this.addedEl.innerHTML =
      (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" class="upsell-product-img">' : '') +
      '<div class="upsell-product-info">' +
        '<p class="upsell-product-name">' + item.product_title + '</p>' +
        (variant ? '<p class="upsell-product-variant">' + variant + '</p>' : '') +
        '<p class="upsell-product-price">' + item.quantity + 'x ' + formatMoney(item.final_price) + '</p>' +
      '</div>';

    // Barra de frete grátis
    var FREE_THRESHOLD = 49900; // R$499,00 em centavos
    var total   = cart.total_price;
    var remains = FREE_THRESHOLD - total;
    var pct     = Math.min(Math.round(total * 100 / FREE_THRESHOLD), 100);
    var fsbHtml;
    if (total >= FREE_THRESHOLD) {
      fsbHtml = '<div class="upsell-fsb">' +
        '<p class="upsell-fsb-msg upsell-fsb-msg--done">&#127881; Você ganhou <strong>frete grátis</strong>!</p>' +
        '<div class="upsell-fsb-track"><div class="upsell-fsb-fill upsell-fsb-fill--done" style="width:100%"></div></div>' +
        '</div>';
    } else {
      fsbHtml = '<div class="upsell-fsb">' +
        '<p class="upsell-fsb-msg">Falta <strong class="upsell-fsb-valor">' + formatMoney(remains) + '</strong> para <strong>frete grátis</strong></p>' +
        '<div class="upsell-fsb-track"><div class="upsell-fsb-fill" style="width:' + pct + '%"></div></div>' +
        '</div>';
    }

    this.actionsEl.innerHTML =
      '<p class="upsell-total">Total (' + count + ' ' + (count === 1 ? 'produto' : 'produtos') + '):<br>' +
        '<strong>' + formatMoney(cart.total_price) + '</strong></p>' +
      fsbHtml +
      '<a href="/checkout" class="upsell-checkout-btn">Finalizar a compra</a>' +
      '<a href="/cart" class="upsell-cart-btn">Ver carrinho</a>' +
      '<button class="upsell-keep-btn" id="upsell-keep-btn">Continuar comprando</button>';

    var keepBtn = document.getElementById('upsell-keep-btn');
    if (keepBtn) keepBtn.addEventListener('click', function() { self.close(); });
  };

  UpsellPopup.prototype._showRecsLoading = function() {
    this.recsSection.removeAttribute('hidden');
    this.recsList.innerHTML = '<p class="upsell-loading">Carregando sugestões...</p>';
  };

  UpsellPopup.prototype._renderRecs = function(products) {
    if (!products || !products.length) {
      this.recsSection.setAttribute('hidden', '');
      return;
    }
    this.recsList.innerHTML = products.map(renderCard).join('');
  };

  UpsellPopup.prototype.open = function() {
    this.overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  };

  UpsellPopup.prototype.close = function() {
    this.overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  };

  function initPopup() {
    new UpsellPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopup);
  } else {
    initPopup();
  }
})();
